import { FastlyImage } from '@components/common/image'

const TrustedByFamilies = () => {
  return (
    <div className="py-12 lg:py-20 bg-white">
      <div className="container mx-auto px-5">
        <h2 className="text-2xl lg:text-4xl font-600 text-center text-grey mb-10 lg:mb-16">
          Trusted by families ❤️ Loved by learners
        </h2>
        <div className="flex items-center flex-col-reverse lg:flex-row gap-8">
          <div className="max-w-4xl mx-auto flex">
            <div
              className="flex-1 lg:grid items-center justify-center gap-2"
              style={{ gridTemplateColumns: '62px auto 62px' }}
            >
              <div className="hidden lg:block self-start col-start-2 col-end-3">
                <FastlyImage
                  src="/images/reviews-and-testimonials/cody-1.png"
                  alt="Cody with bag"
                  width={62}
                  height={69}
                />
              </div>
              <div className="hidden lg:block flex-shrink-0 self-end col-start-1 col-end-2">
                <FastlyImage
                  src="/images/reviews-and-testimonials/cody-3.png"
                  alt="Cody studying"
                  width={62}
                  height={69}
                />
              </div>
              <p className="text-lg lg:text-xl w-full text-center lg:text-left">
                Codingal classes are built around doing. Students learn a
                concept, try it right away, and see it working in the same
                session. Every class includes a hands-on activity, a project, or
                a fun quiz, so learning stays active.
              </p>
              <div className="hidden lg:block flex-shrink-0 self-start">
                <FastlyImage
                  src="/images/reviews-and-testimonials/cody-2.png"
                  alt="Cody"
                  width={62}
                  height={69}
                />
              </div>
              <div
                className="hidden lg:block flex-shrink-0 col-start-2 col-end-3"
                style={{ justifySelf: 'right' }}
              >
                <FastlyImage
                  src="/images/reviews-and-testimonials/cody-4.png"
                  alt="Cody with books"
                  width={62}
                  height={69}
                />
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <FastlyImage
              src="/images/about-us/first-fold/our-students.png"
              alt="Students at Codingal"
              height={380}
              width={380}
              className="object-fill"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrustedByFamilies
